import { TableBody } from '@material-ui/core'
import { tint } from 'polished'
import styled from 'styled-components'

import { type ITableBodyAsRowProps } from '..'

export const TableBodyAsRowStyled = styled(
  ({ hoverable, selected, ...otherProps }: ITableBodyAsRowProps) => (
    <TableBody {...otherProps} />
  )
)`
  height: 0;
  color: ${(props) => props.theme.colors.textPrimary};
  font-weight: ${(props) => props.theme.fontWeights.normal};

  && {
    border-bottom: 1px solid ${(props) => props.theme.colors.content.border};

    ${({ hoverable, theme }) =>
      hoverable
        ? `&:hover {
      background-color: ${theme.colors.table.hover};
    }`
        : ''}

    ${({ selected, theme }) =>
      selected
        ? `{
        background-color: ${tint(0.9, theme.colors.darkGreen)} !important
    }`
        : ''}
  }
`
